<template>
  <Card
    :title="$t('claims.reportClaim.title')"
    :background-color-card="true"
    :header-divider="false"
  >
    <template v-slot:content>
      <p class="mb-32">{{ $t('claims.reportClaim.text') }}</p>

      <!-- Insurance Type Icons -->
      <div class="insurance-icons">
        <HoverableIconBig
          v-for="(icon, index) in insuranceIcons"
          @click="handleIconClick(icon)"
          :key="index"
          :icon-data-span="icon"
          :background="true"
        ></HoverableIconBig>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { Card, HoverableIconBig } from 'de-zurich-ui-library'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { navigate } from '@/utils/NavigationUtils'

interface InsuranceIcon {
  label: string
  iconClass: string
  href: string
}

interface InsuranceTypeConfig {
  label: string
  iconClass: string
  locale: string
  index: number
}

const { tm } = useI18n()

// Base URL from Sitecore config
const baseUrl = globalThis.ENV_CONFIG?.SITECORE.BASE_URL_JSS || ''

// URL Mapping per locale (DA only)
const urlMapping: Record<string, string> = {
  reportAuto: '/schadenservice/autoschaden',
  reportMotorrad: '/schadenservice/motorradschaden',
  reportHausrat: '/schadenservice/hausratschaden',
  reportRechtsschutz: '/schadenservice/rechtsschutzfall',
  reportHaftpflicht: '/schadenservice/haftpflichtschaden',
  reportUnfall: '/schadenservice/unfallversicherung-schadenfall',
  reportWeitere: '/schadenservice'
}

const insuranceIcons = computed((): InsuranceIcon[] => {
  const typesConfig = tm(
    'claims.reportClaim.insuranceTypes'
  ) as unknown as InsuranceTypeConfig[]

  if (!Array.isArray(typesConfig)) {
    console.error('insuranceTypes is not an array:', typesConfig)
    return []
  }

  return typesConfig
    .sort((a, b) => a.index - b.index)
    .map((type: InsuranceTypeConfig) => ({
      label: type.label,
      iconClass: type.iconClass,
      href: urlMapping[type.locale] ? `${baseUrl}${urlMapping[type.locale]}` : ''
    }))
})

const handleIconClick = (icon: InsuranceIcon): void => {
  navigate(icon.href)
}
</script>

<style scoped lang="scss">
.insurance-icons {
  display: flex;
  flex-wrap: wrap;
}
</style>
